import { __extends, __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { Component, forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { baseStyles } from './LoadingSpinner.baseStyles.js';
import { SuomifiThemeConsumer } from '../theme/SuomifiThemeProvider/SuomifiThemeProvider.js';
import '../theme/SuomifiTheme/SuomifiTheme.js';
import { SpacingConsumer } from '../theme/SpacingProvider/SpacingProvider.js';
import { separateMarginProps } from '../theme/utils/spacing.js';
import '../../reset/HtmlA/HtmlA.js';
import '../../reset/HtmlButton/HtmlButton.js';
import { HtmlDivWithRef, HtmlDiv } from '../../reset/HtmlDiv/HtmlDiv.js';
import '../../reset/HtmlFieldSet/HtmlFieldSet.js';
import '../../reset/HtmlH/HtmlH.js';
import '../../reset/HtmlInput/HtmlInput.js';
import '../../reset/HtmlLabel/HtmlLabel.js';
import '../../reset/HtmlLegend/HtmlLegend.js';
import '../../reset/HtmlLi/HtmlLi.js';
import '../../reset/HtmlNav/HtmlNav.js';
import '../../reset/HtmlOl/HtmlOl.js';
import '../../reset/HtmlSpan/HtmlSpan.js';
import '../../reset/HtmlTextarea/HtmlTextarea.js';
import '../../reset/HtmlUl/HtmlUl.js';
import '../../reset/HtmlTable/HtmlTable.js';
import '../../reset/HtmlTable/HtmlTableCaption.js';
import '../../reset/HtmlTable/HtmlTableHeader.js';
import '../../reset/HtmlTable/HtmlTableRow.js';
import '../../reset/HtmlTable/HtmlTableBody.js';
import '../../reset/HtmlTable/HtmlTableHeaderCell.js';
import '../../reset/HtmlTable/HtmlTableCell.js';
import { VisuallyHidden } from '../VisuallyHidden/VisuallyHidden.js';
import { IconPreloader, IconCheckCircleFilled, IconErrorFilled } from 'suomifi-icons';
import { filterDuplicateKeys } from '../../utils/common/common.js';

var baseClassName = 'fi-loadingSpinner';
var loadingSpinnerClassNames = {
  text: "".concat(baseClassName, "_text"),
  textAlignBottom: "".concat(baseClassName, "-textAlign--bottom"),
  textAlignRight: "".concat(baseClassName, "-textAlign--right"),
  small: "".concat(baseClassName, "--small"),
  failed: "".concat(baseClassName, "--failed"),
  loading: "".concat(baseClassName, "--loading"),
  success: "".concat(baseClassName, "--success"),
  icon: "".concat(baseClassName, "_icon")
};
var BaseLoadingSpinner = function (_super) {
  __extends(BaseLoadingSpinner, _super);
  function BaseLoadingSpinner() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  BaseLoadingSpinner.prototype.render = function () {
    var _a;
    var _b = this.props,
      className = _b.className,
      id = _b.id,
      text = _b.text,
      _c = _b.textAlign,
      textAlign = _c === void 0 ? 'bottom' : _c,
      _d = _b.textVisibility,
      textVisibility = _d === void 0 ? 'visible' : _d,
      _e = _b.variant,
      variant = _e === void 0 ? 'normal' : _e,
      _f = _b.status,
      status = _f === void 0 ? 'loading' : _f,
      style = _b.style;
      _b.forwardedRef;
      var rest = __rest(_b, ["className", "id", "text", "textAlign", "textVisibility", "variant", "status", "style", "forwardedRef"]);
    var _g = separateMarginProps(rest),
      passProps = _g[1];
    return /*#__PURE__*/React.createElement(HtmlDivWithRef, __assign({
      className: classnames(baseClassName, className, (_a = {}, _a[loadingSpinnerClassNames.loading] = status === 'loading', _a[loadingSpinnerClassNames.failed] = status === 'failed', _a[loadingSpinnerClassNames.success] = status === 'success', _a[loadingSpinnerClassNames.small] = variant === 'small', _a[loadingSpinnerClassNames.textAlignRight] = textAlign === 'right', _a)),
      asProp: "section",
      id: id
    }, passProps, {
      style: style
    }), status === 'loading' && ( /*#__PURE__*/React.createElement(IconPreloader, {
      className: loadingSpinnerClassNames.icon
    })), status === 'success' && ( /*#__PURE__*/React.createElement(IconCheckCircleFilled, {
      className: loadingSpinnerClassNames.icon
    })), status === 'failed' && ( /*#__PURE__*/React.createElement(IconErrorFilled, {
      className: loadingSpinnerClassNames.icon
    })), textVisibility === 'visible' ? ( /*#__PURE__*/React.createElement(HtmlDiv, {
      className: loadingSpinnerClassNames.text
    }, text)) : ( /*#__PURE__*/React.createElement(VisuallyHidden, null, text)));
  };
  return BaseLoadingSpinner;
}(Component);
var StyledLoadingSpinner = styled(function (props) {
  props.theme;
    props.globalMargins;
    var passProps = __rest(props, ["theme", "globalMargins"]);
  return /*#__PURE__*/React.createElement(BaseLoadingSpinner, __assign({}, passProps));
}).withConfig({
  componentId: "sc-141i9nw-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var theme = _a.theme,
    globalMargins = _a.globalMargins,
    rest = __rest(_a, ["theme", "globalMargins"]);
  var _b = separateMarginProps(rest),
    marginProps = _b[0];
  var cleanedGlobalMargins = filterDuplicateKeys(globalMargins.loadingSpinner, marginProps);
  return baseStyles(theme, cleanedGlobalMargins, marginProps);
});
var LoadingSpinner = /*#__PURE__*/forwardRef(function (props, ref) {
  var passProps = __rest(props, []);
  return /*#__PURE__*/React.createElement(SpacingConsumer, null, function (_a) {
    var margins = _a.margins;
    return /*#__PURE__*/React.createElement(SuomifiThemeConsumer, null, function (_a) {
      var suomifiTheme = _a.suomifiTheme;
      return /*#__PURE__*/React.createElement(StyledLoadingSpinner, __assign({
        forwardedRef: ref,
        theme: suomifiTheme,
        globalMargins: margins
      }, passProps));
    });
  });
});
LoadingSpinner.displayName = 'LoadingSpinner';
var templateObject_1;

export { LoadingSpinner, loadingSpinnerClassNames };
//# sourceMappingURL=LoadingSpinner.js.map
